import { UserStatusEnum } from '@aorg/models/enums/access/UserStatusEnum';
import { UserTypeEnum } from '@aorg/models/enums/access/UserTypeEnum';
import {
  selectSessionAuth,
  selectSessionUser,
  useAppSelector,
} from '@aorg/store';
import { useEffect, useState, type PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function UnauthGuard({ children }: PropsWithChildren) {
  const isAuthenticated = useAppSelector(selectSessionAuth);
  const user = useAppSelector(selectSessionUser);
  const location = useLocation();
  const [redirectAfterLogin] = useState(() =>
    localStorage.getItem('redirectAfterLogin')
  );

  const shouldRedirectHome =
    isAuthenticated && user?.status === UserStatusEnum.Accepted;

  useEffect(() => {
    if (shouldRedirectHome && redirectAfterLogin) {
      localStorage.removeItem('redirectAfterLogin');
    }
  }, [shouldRedirectHome, redirectAfterLogin]);

  if (shouldRedirectHome) {
    return <Navigate to={redirectAfterLogin || '/'} />;
  }

  if (
    isAuthenticated &&
    user?.status === UserStatusEnum.Pending &&
    location.pathname === '/sign-in'
  )
    return <Navigate to="/pending" />;

  if (
    isAuthenticated &&
    user?.status === UserStatusEnum.Waiting &&
    user.type === UserTypeEnum.Stakeholder &&
    location.pathname === '/sign-in'
  )
    return <Navigate to="/waiting" />;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

export default UnauthGuard;
